import * as React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Stack,
  Box,
  Checkbox,
  ListItemButton,
} from "@mui/material";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Loader } from "../../../shared";

export const AddMemberDialog = (props) => {
  const {
    userList,
    handleUsersSelect,
    selectAllText = "All Members",
    isSelectAllChecked,
    onAllSelect,
    hasSelectAll = false,
    isSelected,
    isLoading,
  } = props;
  if (isLoading) {
    return <Loader />;
  }
  return (
    <Box>
      {userList?.length > 0 ? (
        <List sx={{ width: "100%", bgcolor: "background.paper" }}>
          {hasSelectAll && (
            <ListItem key={"all"} disablePadding>
              <ListItemButton
                dense
                sx={{
                  "&:hover": {
                    backgroundColor: "#E6E6E6",
                    borderRadius: "8px",
                  },
                }}
                onClick={(e) => onAllSelect(!isSelectAllChecked)}
              >
                <ListItemIcon
                  sx={{
                    minWidth: "32px",
                  }}
                >
                  <Checkbox
                    edge="start"
                    icon={<CheckBoxOutlineBlankIcon />}
                    checkedIcon={<LibraryAddCheckIcon />}
                    disableRipple
                    checked={isSelectAllChecked}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography fontWeight={500} fontSize="16px">
                      {selectAllText}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
          )}

          {userList?.map((data, index) => (
            <ListItem
              alignItems="flex-start"
              key={index}
              sx={{
                height: "50px",
                padding: " 1px 8px 8px 1px",
                cursor: "pointer",
                ml: 0.5,
              }}
              onClick={() => handleUsersSelect(data.id)}
            >
              <ListItemIcon
                sx={{
                  minWidth: "38px",
                }}
              >
                <Checkbox
                  edge="start"
                  checked={isSelected(data?.id)}
                  disableRipple
                />
              </ListItemIcon>

              <ListItemText
                primary={
                  <>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="subtitle2"
                      color="text.primary"
                      fontWeight={500}
                      fontSize="16px"
                    >
                      {data.first_name}
                    </Typography>
                  </>
                }
                secondary={
                  <>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="caption"
                      color="#657083"
                      fontWeight={400}
                      fontSize="14px"
                    >
                      {data.email}
                    </Typography>
                  </>
                }
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Stack justifyContent="center" alignItems="center" height="100%">
          <Typography
            sx={{ display: "inline" }}
            component="span"
            variant="caption"
            color="text.secondary"
            fontWeight={400}
          >
            There is no users found
          </Typography>
        </Stack>
      )}
    </Box>
  );
};
